export const AUTH_ACTION = 'app/Auth/AUTH_ACTION';
export const REVOKE_AUTH_ACTION = 'app/Auth/REVOKE_AUTH_ACTION';
export const BLOCK_ACCESS_CAMPUS = 'app/Auth/BLOCK_ACCESS_CAMPUS';
export const SET_IS_TUTOR = 'app/Auth/SET_IS_TUTOR';
export const GET_USER_AGENZIE = 'app/Auth/GET_USER_AGENZIE';
export const GET_USER_AGENZIE_FOR_DASHBOARD = 'app/Auth/GET_USER_AGENZIE_FOR_DASHBOARD';
export const GET_USER_ROLES = 'app/Auth/GET_USER_ROLES';
export const GET_USER_PROFILES = 'app/Auth/GET_USER_PROFILES';
export const GET_COLLABORATORE_ID = 'app/Auth/GET_COLLABORATORE_ID';
export const GET_USER_ACL = 'app/Auth/GET_USER_ACL';
export const SET_USER_AGENZIA = 'app/Auth/SET_USER_AGENZIA';
export const LOCK_USER_AGENZIA = 'app/Auth/LOCK_USER_AGENZIA';
export const UNLOCK_USER_AGENZIA = 'app/Auth/UNLOCK_USER_AGENZIA';
export const USER_NOT_FOUND = 'app/Auth/USER_NOT_FOUND';
export const ERROR_USER_ACL = 'app/Auth/ERROR_USER_ACL';



// WEBPACK FOOTER //
// ./app/containers/Auth/constants.js